import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function WhoIsThisForSection() {
  const painPoints = ['Llega la quincena y ya sabes que no va a alcanzar', 'Vives contando cada peso, sintiéndote atrapada', 'No sabes exactamente a dónde se va tu dinero', 'Quieres ahorrar pero siempre surge algo', 'Te da miedo revisar tu cuenta bancaria', 'Sientes que nunca vas a salir de este ciclo'];
  return <section className="w-full py-20 bg-gradient-to-br from-white via-emerald-50/30 to-cyan-50/30" data-id="element-359">
      <div className="max-w-4xl mx-auto px-6" data-id="element-360">
        <div className="text-center mb-12" data-id="element-361">
          <h2 className="font-serif text-4xl lg:text-5xl text-navy-900 mb-6 flex items-center justify-center gap-3" data-id="element-362">
            <span className="text-4xl" data-id="element-363">💰</span>
            Sobrevive a la Quincena
          </h2>
          <p className="text-2xl text-gray-700 font-light" data-id="element-364">
            Un método creado para personas que:
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl p-8 lg:p-12 mb-8" data-id="element-365">
          <div className="space-y-5" data-id="element-366">
            {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-367">
                <CheckCircleIcon className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-1" data-id="element-368" />
                <p className="text-lg text-gray-700 leading-relaxed" data-id="element-369">{point}</p>
              </div>)}
          </div>
        </div>

        <div className="text-center space-y-4" data-id="element-370">
          <p className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto" data-id="element-371">
            No necesitas ganar más para empezar. No necesitas ser experta en
            finanzas.
          </p>
          <p className="text-xl text-navy-900 font-medium leading-relaxed max-w-3xl mx-auto" data-id="element-372">
            Solo necesitas las herramientas correctas para manejar lo que ya
            tienes, de forma inteligente y sin sacrificios extremos.
          </p>
        </div>
      </div>
    </section>;
}